import { create } from 'zustand';

interface BettieProfileUpdateStore {
  editedNickname: string;
  setEditedNickname: (editedNickname: string) => void;
  editedDataUrl: string | null;
  setEditedDataUrl: (editedDataUrl: string | null) => void;
  clear: () => void;
}

export const useBettieProfileUpdateStore = create<BettieProfileUpdateStore>((set) => ({
  editedNickname: '',
  setEditedNickname: (editedNickname) => set({ editedNickname }),
  editedDataUrl: null,
  setEditedDataUrl: (editedDataUrl) => set({ editedDataUrl }),
  clear: () => set({ editedNickname: '', editedDataUrl: null })
}));
